import type { BaseModel } from "@/models/base.model"
import { type Ref } from "vue"

export async function formFocusHack<T extends BaseModel>(
  inputElement: Ref<HTMLElement>,
  model: Ref<T>,
  fieldName: keyof T
) {
  // Situation where text is initially present in the input field.
  const originalValue = model.value[fieldName]
  if (originalValue) {
    delete model.value[fieldName]
    setTimeout(() => {
      model.value[fieldName] = originalValue
      if (inputElement) {
        inputElement.value.focus()
      }
    })
  } else {
    // No initial text present, so we need to add dummy string and then remove it.
    if (inputElement) {
      setTimeout(() => {
        model.value[fieldName] = " " as any
        inputElement.value.focus()
        setTimeout(() => {
          model.value[fieldName] = "" as any
        })
      })
    }
  }
}
